import actionTypes from '../actionTypes';

export function requestProgressiveMissions(payload?: any) {
  return {
    type: actionTypes.PROGRESSIVE_MISSIONS_REQUEST,
    payload
  };
}

export function successProgressiveMissions(payload: any) {
  return {
    type: actionTypes.PROGRESSIVE_MISSIONS_SUCCESS,
    payload,
  };
}

export function failProgressiveMissions(e: any) {
  return {
    type: actionTypes.PROGRESSIVE_MISSIONS_FAIL,
    exception: e,
  };
}

export function updateProgressiveMissions(payload: any) {
  return {
    type: actionTypes.PROGRESSIVE_MISSIONS_UPDATE,
    payload,
  };
}

export function updateProgressiveMissionsChain(missionChain: any, currentIndex: any) {
  return {
    type: actionTypes.PROGRESSIVE_MISSIONS_CHAIN_UPDATE,
    missionChain,
    currentIndex
  };
}

